import {firebaseRoot} from '../../utils/firebase-utils'
import UUID from 'node-uuid';

export default {
    isStarted(exercise, steps, review) {
        return steps.numChildren() > 0;
    },

    isCompleted(exercise, steps, review) {
        // TODO
    },

    isApproved(exercise, steps, review) {
        // TODO
    },

    saveSteps(bookId, chapterId, subchapterId, exerciseId, steps) {
        const key = `/admin/steps/${bookId}/${chapterId}/${subchapterId}/${exerciseId}`;
        // We can't use push when doing atomic multi updates so we just use a UUID as a random key.
        const taskKey = `/admin/queue/tasks/${UUID.v1()}`;
        return firebaseRoot.update({
            [taskKey]: {type: 'object_changed', key: key},
            [key]: steps
        });
    }
}




/** WEBPACK FOOTER **
 ** ./src/admin/models/Exercise.js
 **/